import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'tallymark-1', 'IconTallymark1', [["path",{"d":"M12 5l0 14","key":"svg-0"}]]);